/**
 * @param screen
 * @param identifier - for making unique fields in store's formState for the same UI elements
 * @returns screen
 */
export function withDistinctFieldNames(screen, identifier) {
  return {
    ...screen,
    fields: screen?.fields?.map(field => ({
      ...field,
      name: `__${identifier}:${field.name}`
    }))
  };
}
